/**
 *
 *
 * Usage:
 *
 *   data-sw-input-auto-highlight
 */

var $ = require('./../sw-jquery');

$(document).ready(function() {

  $('body').on('click', '[data-sw-input-auto-highlight]', function(e) {
    $(e.currentTarget).select();
  });

});


